import moment from 'moment';

export default function removeTimeZone(localTime) {
    // Get the timezone for the timeslot
    const timeZone = moment.parseZone(localTime).utcOffset();

    // Adjust the moment-parsed time by the timezone
    const time = moment(localTime);
    time.utcOffset(0);
    time.add(timeZone * 60, 'seconds');

    return time;
}
